import { FC } from 'react';
import { Checkbox } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { toast } from '@/shared/components/toasts/PlatformToast';

import { NotificationChannelConfig, NotificationOptionConfig } from '..';
import { getNotificationChannelGridColumns, NOTIFICATION_OPTION_GRID_WIDTH } from '../layout';

interface NotificationOptionProps {
    channels: NotificationChannelConfig[];
    isChannelEnabled: (workflowKey: string, channel: NotificationChannelConfig['key']) => boolean;
    onChannelChange: (workflowKey: string, channel: NotificationChannelConfig['key'], checked: boolean) => void;
    option: NotificationOptionConfig;
}

const NotificationOption: FC<NotificationOptionProps> = ({
    channels,
    isChannelEnabled,
    onChannelChange,
    option,
}): JSX.Element => {
    const { token } = useAntDesignTheme();
    const gridStyle = {
        alignItems: 'start',
        columnGap: 0,
        display: 'grid',
        gridTemplateColumns: getNotificationChannelGridColumns(channels.length),
        marginBottom: '0.625rem',
        width: NOTIFICATION_OPTION_GRID_WIDTH,
    } as const;
    const checkboxCellStyle = {
        display: 'flex',
        justifyContent: 'center',
        minWidth: 0,
        paddingTop: '0.125rem',
    } as const;

    return (
        <div id={`settings-account-notifications-${option.key}`} style={{ ...gridStyle, scrollMarginTop: '0.75rem' }}>
            <div style={{ minWidth: 0 }}>
                <div style={{ color: token.colorTextSecondary }}>{option.title}</div>
                <div style={{ marginTop: '0.25rem' }}>
                    <small style={{ color: token.colorTextTertiary }}>{option.description}</small>
                </div>
            </div>
            {channels.map((channel) => (
                <div key={channel.key} style={checkboxCellStyle}>
                    <Checkbox
                        checked={isChannelEnabled(option.key, channel.key)}
                        onChange={(event) => {
                            onChannelChange(option.key, channel.key, event.target.checked);
                            toast(`${option.title} (${channel.label})`, {
                                description: event.target.checked ? 'On' : 'Off',
                            });
                        }}
                    />
                </div>
            ))}
        </div>
    );
};

export default NotificationOption;
